/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AccessTokenPermissionAssignmentDto } from './AccessTokenPermissionAssignmentDto';

export type UpdateAccessTokenRequestDto = {
    domains: Array<AccessTokenPermissionAssignmentDto>;
    role: UpdateAccessTokenRequestDto.role;
};

export namespace UpdateAccessTokenRequestDto {

    export enum role {
        ADMIN = 'Admin',
        EDITOR = 'Editor',
        VIEWER = 'Viewer',
        AGENT_SERVICE_ACCOUNT = 'Agent Service Account',
    }


}
